import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import classNames from 'classnames';
var css = {
  "showMore": "rui-9eqEb",
  "placeholder": "rui-elndX",
  "contentMore": "rui-Z5lqo",
  "contentLess": "rui-ntJyA",
  "link": "rui-w2EcE",
  "linkText": "rui-6mBpq",
  "cursorPointer": "rui-S89Mz",
  "cursorAuto": "rui-koqX7",
  "iconContainer": "rui-HbIeA"
};
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
var ShowMore = /*#__PURE__*/function (_React$Component) {
  _inherits(ShowMore, _React$Component);
  var _super = _createSuper(ShowMore);
  function ShowMore(args) {
    var _this;
    _classCallCheck(this, ShowMore);
    _this = _super.call(this, args);
    _this.resize = function () {
      var expanded = _this.state.expanded;
      _this.setState({
        expanded: !expanded
      });
    };
    _this.handleHover = function () {
      _this.setState({
        cursor: css.cursorPointer
      });
    };
    _this.renderIcon = function () {
      var expanded = _this.state.expanded;
      var _this$props = _this.props,
        lessIcon = _this$props.lessIcon,
        moreIcon = _this$props.moreIcon;
      var hasIcons = lessIcon && moreIcon;
      return hasIcons ? /*#__PURE__*/React.createElement("span", {
        className: css.iconContainer
      }, expanded ? lessIcon : moreIcon) : null;
    };
    _this.shortText = function () {
      var _this$props2 = _this.props,
        placeholder = _this$props2.placeholder,
        textLimitChars = _this$props2.textLimitChars;
      return textLimitChars && placeholder.length > textLimitChars ? "".concat(placeholder.slice(0, textLimitChars), " ...") : placeholder;
    };
    var expanded = _this.props.expanded;
    _this.state = {
      expanded: !!expanded,
      cursor: css.cursorAuto
    };
    return _this;
  }
  _createClass(ShowMore, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
        expanded = _this$state.expanded,
        cursor = _this$state.cursor;
      var _this$props3 = this.props,
        placeholder = _this$props3.placeholder,
        more = _this$props3.more,
        less = _this$props3.less,
        markdown = _this$props3.markdown,
        dataAutId = _this$props3.dataAutId;
      if (placeholder !== '' && placeholder !== undefined && placeholder !== null) {
        return /*#__PURE__*/React.createElement("div", {
          className: css.showMore,
          "data-aut-id": dataAutId
        }, /*#__PURE__*/React.createElement("div", {
          className: classNames(css.placeholder, expanded ? css.contentLess : css.contentMore)
        }, markdown ? /*#__PURE__*/React.createElement(ReactMarkdown, {
          rehypePlugins: [rehypeRaw],
          remarkPlugins: [gfm]
        }, placeholder) : /*#__PURE__*/React.createElement("div", null, expanded ? placeholder : this.shortText())), /*#__PURE__*/React.createElement("span", {
          className: css.link
        }, /*#__PURE__*/React.createElement("u", {
          className: classNames(cursor, css.linkText),
          onMouseOver: this.handleHover,
          onFocus: function onFocus() {},
          onClick: this.resize,
          onKeyPress: this.resize,
          tabIndex: 0,
          role: "button"
        }, expanded ? less : more, this.renderIcon())));
      }
      return null;
    }
  }]);
  return ShowMore;
}(React.Component);
ShowMore.defaultProps = {
  dataAutId: ' ',
  placeholder: ' ',
  more: 'View more',
  less: 'View less',
  expanded: false,
  markdown: false,
  lessIcon: null,
  moreIcon: null,
  textLimitChars: 0
};
export default ShowMore;